// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const gstin: CountryValidator<"IN"> = createValidator(
  "in.gstin",
  98,
);

export default gstin;
export const compact = gstin.compact;
export const format = gstin.format;
export const validate = gstin.validate;
export const generate = (): string =>
  gstin.generate?.() ??
  (() => {
    throw new Error(
      "Validator in.gstin cannot generate values",
    );
  })();
